/* eslint-disable react/function-component-definition */
import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormAutocompleteProps } from './types';
import { generatePlaceholderForDropdownField } from '../utils';

// components
import { Autocomplete } from '@ui';

function FormAutocomplete<Option = unknown>({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}: FormAutocompleteProps<Option>) {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    const isMultiSelect = rest.mode === 'multiple';
    return generatePlaceholderForDropdownField(
      isMultiSelect,
      validationRules || [],
      t,
    );
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <Autocomplete {...rest} placeholder={placeholder} />;
}

export default FormAutocomplete;
